export function dateFormatter(inputTime) {
  // Parse the input time
  const date = new Date(inputTime);

  // Get the month name
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];

  // Get the day, year, and time
  const day = date.getDate();
  const year = date.getFullYear();

  // Convert hours to 12-hour format
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // Adjust hours for 12-hour clock

  // Format minutes to always be two digits
  const formattedMinutes = minutes.toString().padStart(2, "0");

  // Combine the formatted parts
  return `${month} ${day}, ${year}, ${hours}:${formattedMinutes} ${period}`;
}
